export class PainelCountdown {
  constructor({
    seconds = 60,
    onTick = () => {},
    onExpire = () => {},
    now = Date.now,
    setInterval,
    clearInterval
  }) {
    this.remaining = seconds
    this.onTick = onTick
    this.onExpire = onExpire
    this.now = now
    this.setInterval = setInterval
    this.clearInterval = clearInterval
    this.timer = null
    this.deadline = null
    this.expired = false
  }

  start() {
    if (this.timer || this.expired) return
    this.deadline = this.now() + (this.remaining * 1000)
    this.onTick(this.remaining)
    this.timer = this.setInterval(() => {
      this.remaining = Math.max(0, Math.ceil((this.deadline - this.now()) / 1000))
      this.onTick(this.remaining)
      if (this.remaining === 0) {
        this.stop()
        this.expired = true
        this.onExpire()
      }
    }, 1000)
  }

  pause() {
    if (!this.timer) return
    this.remaining = Math.max(0, Math.ceil((this.deadline - this.now()) / 1000))
    this.clearInterval(this.timer)
    this.timer = null
    this.deadline = null
  }

  resume() {
    this.start()
  }

  stop() {
    if (this.timer) this.clearInterval(this.timer)
    this.timer = null
    this.deadline = null
  }

  destroy() {
    this.stop()
  }
}
